import { FC } from "react";
import { MdConstruction } from "react-icons/md";

export const Home: FC = () => {
    return (
        <div className="min-h-screen min-w-xl flex flex-col items-center justify-center">
            <h1 className="text-4xl text-center" area-label="Under Construction">
                <MdConstruction style={{ display: "inline-block" }} color="#f7cd4c" title="Under Construction"/>
                <span>DISCLAIMER</span>
                <MdConstruction style={{ display: "inline-block" }} color="#f7cd4c" title="Under Construction"/>
            </h1>
            <p className="mt-5 text-center">
                This service is still under heavy construction.<br/>
                <br/>
                <span className="font-bold text-red-800">No guarantees are made about the content or functionality of this service.</span><br/>
                <br/>
                Like what I'm building? Feel free to leave a tip: <a className="link" href="https://www.paypal.com/ncp/payment/5NYEPSTTFK4KW" target="_blank" rel="noreferrer">PayPal</a>
            </p>
            <hr className="w-full my-5 bg-white"/>
            <div className="mt-3">
                <span className="font-bold">Current State:</span>
                <ul className="list-disc list-inside mt-3">
                    <li> Donations
                        <ul className="list-disc list-inside ml-10">
                            <li>
                                Support for Donations from Ko-fi, StreamElements and Tipeee
                                <ul className="list-disc list-inside ml-10">
                                    <li>At this moment setting up Donation Providers requires some manual work from the Streamer and me until I get around to implementing proper Setup Processes.</li>
                                </ul>
                            </li>
                            <li>
                                Fallback Support for Donations via Bot-Chat-Messages
                                <ul className="list-disc list-inside ml-10">
                                    <li>This way practically any Provider can be supported as long as there's a Bot posting messages into your Channel.</li>
                                </ul>
                            </li>
                            <li>
                                <span className="text-yellow-400">Under Construction (short-term)</span>:
                                <ul className="list-disc list-inside ml-10">
                                    <li>Support for currencies other than Euro (€)</li>
                                    <li>Linking Accounts for StreamElements and later Streamlabs (at this moment a manual setup is still required)</li>
                                    <li>Help Page setting up Tipeee Donations using API Token (at this moment a manual setup is still required)</li>
                                    <li>Help Page setting up Ko-fi Donations</li>
                                    <li>Allow managing the messages the Bots from your Donation Providers send to recognize external donations</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        Donation-Train
                        <ul className="list-disc list-inside ml-10">
                            <li>Full credits for the Donation-Train go to <a className="link" href="https://twitch.tv/ailenax">@Ailenax on Twitch.tv</a></li>
                            <li>Train-Levels up to Level 30</li>
                            <li>Customizable Durations</li>
                            <li>
                                <span className="text-yellow-400">Under Construction (short-term)</span>:
                                <ul className="list-disc list-inside ml-10">
                                    <li>Improved customizability (styling)</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        Goals
                        <ul className="list-disc list-inside ml-10">
                            <li>Inspired by the needs of <a className="link" href="https://twitch.tv/dirkneuenfels">@DirkNeuenfels on Twitch.tv</a></li>
                            <li>At this moment only Donation-Goals are supported.</li>
                            <li>Donations from all providers (StreamElements, Ko-fi, Tipeee, ...) automatically count towards the goals</li>
                            <li>
                                <span className="text-yellow-400">Under Construction (short-term)</span>:
                                <ul className="list-disc list-inside ml-10">
                                    <li>"Create Goal"-Page (at this moment I have to manually setup multiple goals</li>
                                    <li>Improved customizability (styling)</li>
                                    <li>Support for Sub- and Bit-Goals</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <span className="text-red-400">Necessities (short-term)</span>:
                        <ul className="list-disc list-inside ml-10">
                            <li>
                                Legal (Privacy Policy, Terms of Service, ...)
                                <ul className="list-disc list-inside ml-10">
                                    <li>We all hate those, yet they're still needed for a professional relationship.</li>
                                    <li>In the meantime: This service is provided "as-is" and no guarantees are made on current or future functionality.</li>
                                    <li>Consider this an "early access", your Feedback and Requests will shape this service.</li>
                                    <li>With that said: I'll do my best to maintain a working solution and communicate big changes beforehand.</li>
                                </ul>
                            </li>
                            <li>
                                Centralized Communication Channel
                                <ul className="list-disc list-inside ml-10">
                                    <li>Necessary for News, Bug-Reports, Feature Requests, Commissions etc.</li>
                                    <li>In the meantime: Ping me on Discord (cckep) or Twitch (ccKep)</li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <span className="text-yellow-400">Planned Features (mid-term)</span>:
                        <ul className="list-disc list-inside ml-10">
                            <li>Filterable real-time Activity-Feed</li>
                            <li>Alerts</li>
                            <li>Dashboard and Analytics</li>
                        </ul>
                    </li>
                    <li>
                        <span className="text-yellow-400">Planned Features (long-term)</span>:
                        <ul className="list-disc list-inside ml-10">
                            <li>Proper User- and Session-System</li>
                            <li>Redesigning the Configuration Pages and building a responsive layout</li>
                            <li>Multi-Channel support</li>
                            <li>Chat-Bot functionality (Commands, Timers, Counters, ...)</li>
                            <li>Various Exports (csv)</li>
                        </ul>
                    </li>
                    <li>
                        <span className="text-yellow-400">Planned Features (distant future, lower priority for now)</span>:
                        <ul className="list-disc list-inside ml-10">
                            <li>Support for different languages (i18n)</li>
                            <li>Support for sharing access and multiple Roles (like Editor or Moderator etc.)</li>
                        </ul>
                    </li>
                </ul>
            </div>
            <p className="mt-5 text-center">
                Missing something? Individual Requests?<br/>
                Feel free to ping me on Discord (cckep) or Twitch (ccKep)!
            </p>
        </div>
    );
}